import {
  Interaction,
  InteractionItem,
  InteractionModeFunction,
  Tooltip,
  TooltipPositionerFunction,
} from 'chart.js';
declare module 'chart.js' {
  interface InteractionModeMap {
    nearestPerDataset: InteractionModeFunction;
  }
  interface TooltipPositionerMap {
    cursor: TooltipPositionerFunction<'line'>;
  }
}
/**
 * Selects the point with the nearest timestamp at or before the cursor, from each dataset.
 *
 * Unlike "index" mode, this does not assume that the same data index
 * represents the same timestamp across datasets.
 */
Interaction.modes.nearestPerDataset = (chart, event): InteractionItem[] => {
  if (event.x == null) return [];

  const xScale = chart.scales.x;
  if (!xScale) return [];

  const targetTimestamp = xScale.getValueForPixel(event.x);
  if (targetTimestamp == null) return [];

  return chart.data.datasets.flatMap((dataset, datasetIndex) => {
    let closestIndex = -1;
    let closestDistance = Infinity;
    dataset.data.forEach((point, dataIndex) => {
      if (point == null || typeof point !== 'object' || !('x' in point)) {
        return;
      }
      const { x: timestamp } = point;
      if (timestamp == null) return;
      if (timestamp > targetTimestamp) return;

      const distance = targetTimestamp - timestamp;
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = dataIndex;
      }
    });
    if (closestIndex === -1) return [];
    const element = chart.getDatasetMeta(datasetIndex).data[closestIndex];
    if (!element) return [];
    return [
      {
        element,
        datasetIndex,
        index: closestIndex,
      },
    ];
  });
};

Tooltip.positioners.cursor = function (_elements, eventPosition) {
  return {
    x: eventPosition.x,
    y: eventPosition.y,
  };
};
